import Swal from "sweetalert2";

export const AlertasMixin = {
    methods: {
        confirmar: function(titulo, mensagem){
            return new Promise((resolve) => {
                Swal.fire({
                    title: titulo,
                    text: mensagem,
                    icon: "warning",
                    showDenyButton: true,
                    confirmButtonText: 'Sim',
                    denyButtonText: `Não`
                }).then((result) =>{
                    resolve(result.isConfirmed);
                });
            });
        },
        alertaSucesso: function(mensagem){
            return new Promise((resolve) => {
                Swal.fire({
                    title: "Sucesso",
                    text: mensagem,
                    icon: "success",
                }).then(() =>{
                    resolve();
                });
            });
        },
        alertaErro: function(mensagem){
            Swal.fire({
                title: "Erro",
                html: mensagem,
                icon: "error",
                confirmButtonText: "Ok"
            });
        },
        alertaAviso: function(mensagem){
            Swal.fire({
                title: "Aviso",
                text: mensagem,
                icon: "warning",
                confirmButtonText: "Ok"
            });
        },
        toast: function(mensagem, options){
            this.$bvToast.toast(mensagem, {
                title: options.title ? options.title : "",
                toaster: options.position ? options.position : 'b-toaster-bottom-right',
                solid: true,
                appendToast: true,
                variant: options.variant ? options.variant : 'info',
            });
        },

        toastSucesso: function(mensagem){
            this.toast(mensagem, {
                title: "Sucesso",
                toaster: 'b-toaster-bottom-right',
                solid: true,
                appendToast: true,
                variant: "success"
            });
        },

        toastErro: function(mensagem){
            this.toast(mensagem, {
                title: "Erro",
                toaster: 'b-toaster-bottom-right',
                solid: true,
                appendToast: true,
                variant: "danger"
            });
        }
    },
}